import { render, staticRenderFns } from "./CheckboxElement.vue?vue&type=template&id=42140c8b&scoped=true&"
import script from "./CheckboxElement.vue?vue&type=script&lang=js&"
export * from "./CheckboxElement.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxElement.vue?vue&type=style&index=0&id=42140c8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42140c8b",
  null
  
)

export default component.exports